import './LoaderTopMovie.scss'

export const LoaderTopMovie = () => {

    return (
        <div className='skeleton-top'>
            <ul className="skeleton-top__list">
            <li className='skeleton-top__item'></li>
            <li className='skeleton-top__item'></li>
            <li className='skeleton-top__item'></li>
            <li className='skeleton-top__item'></li>
            </ul>
        </div>

    )
}

